import { Component, OnInit, Pipe, PipeTransform  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';



@Component({

})
export class ErrorComponent {
  public data;

  constructor(
    private router: Router,
    private toasterService: ToasterService) {
  }

  renderSuccessMsg(text){
    this.toasterService.pop('success', '', text);
  }

  renderWarningMsg(text){
    this.toasterService.pop('warning', '', text);
  }

  public renderError(error) {
    this.toasterService.pop('error', '', error.errMsg);
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/errorComponent/error.component.ts